import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";

import { ContractUpdateTerm, UPDATE_TERM_OPTIONS } from "../helpers";

interface IUpdateTermFieldsProps {
  /** Gate: the whole block is hidden until a next update date is picked. */
  nextUpdateDate: Date | null;
  updateTerm: ContractUpdateTerm | null;
  updatePercent: number | null;
  onUpdateTermChange: (value: ContractUpdateTerm | null) => void;
  onUpdatePercentChange: (value: number | null) => void;
  /** Grid classes for each field, so Create (2 cols) and Edit (3 cols) can lay them out alike. */
  fieldClassName?: string;
}

/**
 * CLE-2781 — the update terms that appear once a next update date is set: what happens to the
 * rates on that date, and (for a percent increase) by how much.
 *
 * Renders nothing without a date. That is deliberate rather than a disabled state: a term with
 * no date says when nothing, and the API rejects the pair outright.
 */
export function UpdateTermFields({
  nextUpdateDate,
  updateTerm,
  updatePercent,
  onUpdateTermChange,
  onUpdatePercentChange,
  fieldClassName = "col-12 md:col-6",
}: IUpdateTermFieldsProps) {
  if (!nextUpdateDate) return null;

  return (
    <>
      <div className={fieldClassName}>
        <label className="block text-900 font-medium mb-2">Update Term</label>
        <Dropdown
          value={updateTerm}
          options={UPDATE_TERM_OPTIONS}
          onChange={(e) => onUpdateTermChange(e.value ?? null)}
          placeholder="Select Update Term"
          className="w-full"
          showClear
        />
        <small className="text-600 mt-1 block">
          What happens to the rates on the next update date.
        </small>
      </div>
      {updateTerm === "PercentIncrease" && (
        <div className={fieldClassName}>
          <label className="block text-900 font-medium mb-2">
            Percent Increase *
          </label>
          <InputNumber
            value={updatePercent}
            onValueChange={(e) => onUpdatePercentChange(e.value ?? null)}
            placeholder="e.g. 3"
            className="w-full"
            suffix="%"
            minFractionDigits={0}
            maxFractionDigits={2}
            min={0}
          />
        </div>
      )}
    </>
  );
}

export default UpdateTermFields;
